module.exports = __webpack_public_path__ + "static/media/wrecker_pink.40076ec2.svg";